module.exports = __webpack_public_path__ + "img/progress-circle-lg-white-static.svg?37b7eba1b9bfe35cde2cb3dace133020";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pages/img/progress/progress-circle-lg-white-static.svg
// module id = 260
// module chunks = 0